import { Component } from 'react';
import { getYears, DEFAULT_YEAR } from './keys';

class AdditionalBox extends Component {
    constructor() {
        super();

        this.years = getYears();
    }

    render() {
        return (
            <div className="table-header-extra-view">
                {this.years.map((item) => {
                    const activeYear = this.props.year ?? DEFAULT_YEAR;
                    return (
                        <button
                            className={`table-header-extra-view-btn ${
                                activeYear === item.value && 'table-header-extra-view-btn-active'
                            }`}
                            key={item.value}
                            onClick={() => this.props.getData(item.value)}
                            disabled={activeYear === item.value}
                        >
                            {item.label}
                        </button>
                    );
                })}
            </div>
        );
    }
}

export default AdditionalBox;
